import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import { TraderGroupPromiseLookupService } from "../../../lookup/model/impl/TraderGroupPromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuFillApproveItemState extends ContextMenuItemState {
  constructor(
    count: number = 0,
    itemIndex: number = 0,
    available: boolean = true,
    enabled: boolean = true,
    title: string = "",
  ) {
    super(count, itemIndex, available, enabled, title);
  }
}
